<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      :searchDesc="searchDesc"
      @searchSubmit="searchSubmit"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="50%">
      <span class="info-class">
        <div class="item" style="width: 100%;">
          <div class="left">产品名称</div>
          <div class="right">{{ info.body }}</div>
        </div>
        <div class="item">
          <div class="left">订单金额</div>
          <div class="right">￥{{ info.fee }}元</div>
        </div>
        <div class="item">
          <div class="left">游玩时间</div>
          <div class="right">{{ info.plan }}</div>
        </div>
        <div class="item">
          <div class="left">订单号</div>
          <div class="right">{{ info.trade_no }}</div>
        </div>
        <div class="item">
          <div class="left">第三方单号</div>
          <div class="right">{{ info.api_sn }}</div>
        </div>
        <div class="item">
          <div class="left">联系人</div>
          <div class="right">{{ info.link_name }}</div>
        </div>
        <div class="item">
          <div class="left">联系人电话</div>
          <div class="right">{{ info.link_mobile }}</div>
        </div>
        <div class="item">
          <div class="left">渠道商</div>
          <div class="right">{{ info.share_member }}</div>
        </div>
        <div class="item" style="width: 100%;">
          <div class="left">订单备注</div>
          <div class="right">{{ info.share_member }}</div>
        </div>
        <div class="credentials">
          <div class="credentials-body">
            <div class="credentials-item">
              <div class="item-left">游客姓名</div>
              <div class="item-right">游客身份证</div>
            </div>
            <div v-for="(item,index) in info.product" :key="index">
            <div>产品名称：{{ item.goodsName }}</div>
            <div class="credentials-item" v-for="vo in item.credentials" :key="vo.id">
              <div class="item-left">{{ vo.name }}</div>
              <div class="item-right">{{ vo.id }}</div>
            </div>
            </div>
          </div>
        </div>
      </span>
    </el-dialog>
    <ele-form-dialog
      v-model="pushData"
      :formDesc="pushDesc"
      :request-fn="pushHandleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      :visible.sync="pushTitcket"
      :title="'订单出票'"
    >
    </ele-form-dialog>
  </div>
</template>
<script>
import * as order from "@/api/product/order.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      dialogVisible: false,
      pushTitcket: false,
      info: [],
      searchDesc: {
        // -1 订单过期
        // 0未支付
        // 1支付成功
        // 2支付失败
        // 3已出票
        // 4出票失败，已退款
        // 5退款中
        // 6退款成功
        // 7返现成功
        link_name: {
          type: "input",
          label: "联系人"
        },
        link_mobile: {
          type: "input",
          label: "联系人电话"
        },
        trade_no: {
          label: "订单号",
          type: "input"
        },
        status: {
          label: "订单状态",
          type: "select",
          options: [
            {
              text: " 订单过期",
              value: -1
            },
            {
              text: "未支付",
              value: 0
            },
            {
              text: "支付成功",
              // type: "success",
              value: 1
            },
            {
              text: "支付失败",
              value: 2
            },
            {
              text: "已出票",
              value: 3
            },
            {
              text: "出票失败，已退款",
              value: 4
            },
            {
              text: "取消中",
              value: 5
            },
            {
              text: "退款成功",
              value: 6
            },
            {
              text: "返现成功",
              value: 7
            },
            {
              text: "退款中",
              value: 9
            }
          ]
        },
        date_type: {
          label: "日期类型",
          type: "select",
          default: 1,
          options: [
            {
              text: "订单日期",
              value: 1
            },
            {
              text: "游玩日期",
              value: 2
            }
          ]
        },
        date: {
          field: "date",
          label: "时间范围",
          type: "daterange",
          attrs: {
            valueFormat: "yyyy-MM-dd",
            pickerOptions: {
              shortcuts: [
                {
                  text: "最近一周",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近一个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近三个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                  }
                }
              ]
            }
          }
        },
        platform: {
          label: "所属平台",
          type: "select",
          options: [
            {
              text: "微信",
              value: "weixin"
            },
            {
              text: "抖音",
              value: "toutiao"
            },
            {
              text: "支付宝",
              value: "alipay"
            }
          ]
        }
      },
      searchData: {},
      pushDesc: {
        type: {
          type: "radio",
          label: "处理类型",
          options: [
            { text: "第三方出票", value: "api" },
            { text: "窗口出票", value: "manual" }
          ]
        }
      },
      pushData: {},
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 25,
        pageSizes: [15, 25, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "计划",
        // 多选 默认:false;
        selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: true,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: false,
        expandStyle: "width:50%;display:inline-flex;",
        column: [
          {
            prop: "trade_no",
            // 列名
            label: "订单号",
            hide: true
          },
          {
            prop: "link_name",
            // 列名
            label: "联系人",
            width: 120,
            hide: true
          },
          {
            prop: "platform",
            // 列名
            label: "所属平台",
            width: 120,
            hide: true
          },
          {
            prop: "link_mobile",
            // 列名
            label: "联系人电话",
            hide: false
          },
          {
            prop: "link_idcard",
            // 列名
            label: "下单人身份证号",
            hide: false
          },
          {
            prop: "body",
            // 列名
            label: "产品名称",
            hide: true
          },
          {
            prop: "quantity",
            // 列名
            label: "数量",
            width: 80,
            hide: true
          },
          //   {
          //     prop: "type",
          //     // 列名
          //     label: "日志类型",
          //     hide: true
          //   },
          {
            prop: "create_time",
            // 列名
            label: "订单创建时间",
            hide: true
          },
          {
            prop: "ip",
            // 列名
            label: "发起支付IP",
            hide: false
          },
          {
            prop: "status",
            // 列名
            label: "订单状态",
            show: "tag",
            hide: true,
            width: 150,
            tagtype: [
              {
                text: " 订单过期",
                type: "danger",
                value: -1
              },
              {
                text: "未支付",
                type: "warning",
                value: 0
              },
              {
                text: "支付成功",
                type: "success",
                value: 1
              },
              {
                text: "支付失败",
                type: "danger",
                value: 2
              },
              {
                text: "已出票",
                type: "success",
                value: 3
              },
              {
                text: "出票失败，已退款",
                type: "danger",
                value: 4
              },
              {
                text: "取消中",
                type: "warning",
                value: 5
              },
              {
                text: "退款成功",
                type: "info",
                value: 6
              },
              {
                text: "返现成功",
                type: "success",
                value: 7
              },
              {
                text: "退款中",
                type: "warning",
                value: 9
              }
            ]
          }
        ],
        btnNavLeft: [
          {
            text: "导出",
            size: "mini",
            type: "",
            click: () => {
              let that = this;
              let param;
              if (this.searchData) {
                param = {
                  type: 1,
                  ...this.searchData
                };
              }
              order.exportFile.r(param).then(res => {});
            }
          }
        ],
        btnList: [
          {
            name: "详情",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.info = row;
              this.dialogVisible = true;
            }
          },
          {
            name: "退单",
            size: "mini",
            type: "text",

            click: (id, row, index) => {
              this.$confirm("确定要退回此订单?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  order.refundOrder.r({ id: row.order_id }).then(res => {
                    console.log(res);
                    if (res) {
                      this.$message.success("退单成功");
                    }
                    this.getlist();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消退单"
                  });
                });
            }
          },
          {
            name: "出票",
            size: "mini",
            type: "text",
            Vif: data => {
              return data.status == 1;
            },
            click: (id, row, index) => {
              this.pushData = row;
              this.pushTitcket = true;
              this.$confirm("确定要推送此订单?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  order.pushOrder.r({ id: row.order_id }).then(res => {
                    if (res) {
                      this.$message.success("推送成功");
                    }
                    this.getlist();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消推送"
                  });
                });
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    pushHandleSubmit() {
      //推送订单提交
      order.pushOrder.r({ ...this.pushData }).then(res => {
        if (res) {
          this.pushTitcket = false;
          this.$message.success("出票成功");
        }
        this.getlist();
      });
    },
    // 搜索提交
    searchSubmit(e) {
      this.searchData = e;
      if (e.date) {
        let date = {
          start_time: e.date[0],
          end_time: e.date[1]
        };
        delete e.date;
        this.searchData = {
          ...e,
          ...date
        };
      }
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    getlist(e) {
      let that = this;
      let param;
      if (e) {
        that.page = e;
        param = {
          type: 1,
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          type: 1,
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          type: 1,
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      order.getOrderList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.info-class {
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 50%;
    display: flex;
    line-height: 40px;
    font-size: 14px;
    // &:nth-child(1) {
    //   border-top: 1px solid #dcdfe6;
    // }
    // border-bottom: 1px solid #dcdfe6;
    .left {
      font-weight: 500;
      font-size: 13px;
      padding-left: 10px;
      margin-right: 10px;
      width: 90px;
    }
    .right {
      width: calc(100% - 100px);
      color: #303133;
    }
  }

  .credentials {
    margin-top: 10px;
    line-height: 35px;
    width: 100%;
    .credentials-body {
      width: 100%;
      .credentials-item {
        width: 100%;
        display: flex;
        &:nth-child(odd) {
          background-color: #f7f7f7;
        }

        .item-left {
          width: 50%;
          padding-left: 10px;
        }
        .item-right {
          padding-left: 10px;
          width: 50%;
        }
      }
    }
  }
}
</style>
